<template>
  <div class="w-full text-center md:text-left md:absolute md:top-5 md:left-5 md:w-auto xl:px-4">
    <p class="text-4xl md:text-5xl mt-2 md:mt-4">Build a bet with friends</p>

    <p class="text-2xl md:text-4xl mt-2 md:mt-4 md:mx-8 text-center">
      Askodds a new revolutionary way to build a bet with friends. No need to share bet slip
      screenshots or messaging picks with Askodds technology you can share your selections pre bet
      placement with odds, via messaging apps for friends to edit, add selections, get the best
      odds, share back to all and place a bet with best odds bookmaker or your favourite bookmaker.
    </p>

    <ul class="mt-3 md:mt-4 space-y-2 md:space-y-4 mx-4">
      <li class="text-lg md:text-2xl mt-2 md:mt-4">
        <i class="pi pi-check"></i> Easy <i class="pi pi-minus"></i> Type or speak your bet
        selections
      </li>
      <li class="text-lg md:text-2xl mt-2 md:mt-4">
        <i class="pi pi-check"></i> Fast <i class="pi pi-minus"></i> Betting odds compared instantly
        from 20+ bookies
      </li>
      <li class="text-lg md:text-2xl mt-2 md:mt-4">
        <i class="pi pi-check"></i> Shareable <i class="pi pi-minus"></i> Pass on to friends via any
        messenger app for them to add or edit selections and share back
      </li>
      <li class="text-lg md:text-2xl mt-2 md:mt-4">
        <i class="pi pi-check"></i> Bet <i class="pi pi-minus"></i> Bet slip populated instantly to
        place bet with one click
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts"></script>
